import { render, staticRenderFns } from "./wind-info.vue?vue&type=template&id=4aa7e362"
import script from "./wind-info.vue?vue&type=script&lang=js"
export * from "./wind-info.vue?vue&type=script&lang=js"
import style0 from "./wind-info.vue?vue&type=style&index=0&id=4aa7e362&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports